import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { FirmDashboard } from '@/features/jobs/dashboard/components/FirmDashboard'
import { type FirmDashboardViewModel } from '@/features/jobs/dashboard/FirmDashboardViewModel'
import { FirmDashboardViewHeadingContainer } from '@/features/jobs/dashboard/components/FirmDashboardViewHeadingContainer'
import { FirmDashboardOverviewSidebarContainer } from '@/features/jobs/dashboard/components/FirmDashboardOverviewSidebar/FirmDashboardOverviewSidebarContainer'
import { FirmDashboardQuickSelectFilterContainer } from '@/features/jobs/dashboard/components/FirmDashboardQuickSelectFilter/FirmDashboardQuickSelectFilterContainer'
import { FirmDashboardJobCountContainer } from '@/features/jobs/dashboard/components/FirmDashboardJobCount/FirmDashboardJobCountContainer'
import { FirmDashboardJobsViewerContainer } from '@/features/jobs/dashboard/components/FirmDashboardJobsViewer/FirmDashboardJobsViewerContainer'
import { FirmDashboardJobsViewerHeaderContainer } from '@/features/jobs/dashboard/components/FirmDashboardJobsViewerHeader/FirmDashboardJobsViewerHeaderContainer'
import { useDocumentTitle } from '@/hooks/document-title'
import { useActivation } from '@/hooks/view-model-hooks'

export default observer(function FirmDashboardContainer() {
  const { internal } = useFeatures(({ jobs }) => ({
    internal: jobs.internal(),
  }))
  return <FirmDashboardViewContainer vm={internal.firmDashboardViewModel} />
})

interface FirmDashboardViewContainerProps {
  vm: FirmDashboardViewModel
}

const FirmDashboardViewContainer = observer(
  function FirmDashboardViewContainer({ vm }: FirmDashboardViewContainerProps) {
    useDocumentTitle('Dashboard')
    useActivation(vm)

    return (
      <FirmDashboard
        heading={<FirmDashboardViewHeadingContainer vm={vm} />}
        overviewSidebar={
          <FirmDashboardOverviewSidebarContainer vm={vm.overviewSidebarVm} />
        }
        quickSelectFilter={
          <FirmDashboardQuickSelectFilterContainer
            vm={vm.quickSelectFilterVm}
          />
        }
        jobCount={<FirmDashboardJobCountContainer vm={vm.jobTableVm} />}
        jobsViewerHeader={
          <FirmDashboardJobsViewerHeaderContainer vm={vm.jobTableVm} />
        }
        jobsViewer={<FirmDashboardJobsViewerContainer vm={vm.jobTableVm} />}
      />
    )
  },
)
